import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Location } from '@angular/common';
import { NavigationComponent } from '../../components/navigation/navigation.component';
@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    RouterModule,
    MatIconModule,
    NavigationComponent,
  ],
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.scss',
})
export class EditUserComponent {
  location: Location = inject(Location);
  private authService = inject(AuthService);
  private router: Router = inject(Router);

  showLogin = false;
  showPassordButton = true;

  $authError = signal('');

  form = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    password1: new FormControl('', [Validators.required]),
    password2: new FormControl('', [Validators.required]),
  });

  gotoLogin() {
    this.authService.logout();
    this.router.navigate(['auth']);
  }

  onChangePassword() {
    const pass1 = this.form.controls.password1.value;
    const pass2 = this.form.controls.password2.value;
    if (pass1 && pass2 && pass1 === pass2) {
      if (pass1 !== null && pass1.length > 6) {
        this.authService
          .updatePassword(pass1)
          .then(() => {
            this.$authError.set(
              'Ihr Passwort wurde erfolgreich geändert. Bitte loggen Sie sich nun mit Ihrem neuen Passwort erneut ein.'
            );
            // this.authService.logout();
            this.showPassordButton = false;
            this.showLogin = true;
            this.form.get('password1')?.disable();
            this.form.get('password2')?.disable();
          })
          .catch(error => {
            console.log('error ', error);
            if (error.code === 'auth/requires-recent-login') {
              this.$authError.set('Sie müssen sich zunächst erneut einloggen.');
              this.form.get('password1')?.disable();
              this.form.get('password2')?.disable();
              this.showPassordButton = false;
              this.showLogin = true;
            }
          });
      } else {
        this.$authError.set('Das Passwort muss mindestens 6 Zeichen lang sein');
      }
    } else {
      this.$authError.set('Die Passwörter stimmen nicht überein');
    }
  }
}
